<style>
.modal-header .close {
  display:none;
}
</style>
<template>
  <div>


    <b-modal size="xl" ref="my-modal" hide-footer title="Welcome to Veeam Live – Cloud Data Best Practices" class="modal" no-close-on-backdrop>


      <BizzaboForm></BizzaboForm>

    </b-modal>
  </div>
</template>

<script>

import BizzaboForm from "@/components/form/BizzaboForm";

export default {

  components: {
   BizzaboForm
  },
  mounted() {
    this.showModal()
  },
  methods: {
    showModal() {
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['my-modal'].toggle('#toggle-btn')
    }
  }
}
</script>



<style scoped>

  div {
    font-family: guardianfont;
  }

</style>